/* Gunnaro — predictive-search.js
   <predictive-search> wraps the search form in the search drawer. Results are rendered
   server-side by sections/predictive-search.liquid (Shopify Predictive Search API).
   Without JS the form submits to /search. */
class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-results]');
    this.status = this.querySelector('[data-predictive-status]');
    this.cache = new Map();
    this.controller = null;
    this.timer = null;
    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.search(this.input.value.trim()), 180);
    });
    this.querySelector('[data-search-clear]')?.addEventListener('click', () => {
      this.input.value = '';
      this.render('');
      this.input.focus();
    });
  }

  async search(term) {
    if (term.length < 2) return this.render('');
    if (this.cache.has(term)) return this.render(this.cache.get(term));

    this.controller?.abort();
    this.controller = new AbortController();
    this.setAttribute('aria-busy', 'true');
    const url = new URL(window.Gunnaro.routes.predictiveSearch, window.location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('section_id', 'predictive-search');
    url.searchParams.set('resources[type]', 'product,collection,article,page');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][fields]', 'title,vendor,product_type,variants.sku,tag');

    try {
      const res = await fetch(url, { signal: this.controller.signal });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const html = doc.querySelector('[data-predictive-content]')?.innerHTML || '';
      this.cache.set(term, html);
      this.render(html);
    } catch (err) {
      if (err.name !== 'AbortError') this.render('');
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  render(html) {
    this.results.innerHTML = html;
    this.results.hidden = !html;
    this.classList.toggle('has-results', !!html);
    const count = this.results.querySelectorAll('[data-result]').length;
    if (this.status) this.status.textContent = html ? (this.status.dataset.template || '{count}').replace('{count}', count) : '';
  }
}
customElements.define('predictive-search', PredictiveSearch);
